<template>
  <div class="h-100">
    <div class="card">
      <div class="card-body p-0">
        <div class="row w-100 m-0">
          <div class="col-12 tenders-list p-0">
            <tender-info-block :key="tenderData.id" v-if="tenderData" :tender="tenderData"/>
            <div v-if="similarTenders.length" class="d-flex flex-wrap gap-2 padding-10">
              <div class="divider"></div>
              <p class="font-weight-bold similar-tenders-text padding-l-10 padding-b-10">Նմանատիպ ապրանքներ</p>
              <div class="col-12 tenders-list p-0">
                <div class="d-flex flex-wrap gap-2">
                  <tender-card @click="() => handleSimilarClick(tender)" :tender="tender" :selectedType="'all'" :can-favorite="false" :can-edit="false" v-for="tender in similarTenders" :key="tender.id"/>
                </div>
              </div>
            </div>
            <div v-else class="padding-b-20"></div>
          </div>
        </div>
      </div>
    </div>
    <timeless-confirm-modal/>
    <new-editor-modal :tender="contractData" @handleGetContract="handleGetContract"/>
  </div>
</template>
<script>
  import isMobile from '@/mixins/isMobileView'
  import TenderInfoBlock from '@/components/timelessTenders/TenderInfoBlock.vue'
  import TimelessConfirmModal from '@/components/helpers/TimelessConfirmModal.vue'
  import { required } from 'vuelidate/lib/validators'
  import NewEditorModal from '@/views/fileManagment/timeless/NewEditorModal.vue'
  import TenderCard from '@/components/timelessTenders/tenderCard.vue'

  export default {
    components: { TenderCard, NewEditorModal, TenderInfoBlock, TimelessConfirmModal },
    mixins: [isMobile],
    data() {
      return {
        dateNow: new Date(),
        backendUrl: process.env.VUE_APP_URL,
        contractData: {
          rows: [
            {
              name: 'name',
              specification: 'specification',
              unit: 'unit',
              count: 'count',
              terms_of_purchase: 'terms_of_purchase',
              delivery_terms: 'delivery_terms',
              offer_delivery_terms: 'offer_delivery_terms',
              payment_terms: 'payment_terms',
              delivery_address: 'delivery_address',
            },
          ]
        },
        tenderData: false,
        countGreaterThenOffer: false,
        contractHtml: '',
        mainPicture: '',
        similarTenders: [],
        selectedOffer: {
          phone_number: '096336628'
        },
        totalAmount: '',
        order: {
          timeless_tender_id: this.$route.params.tenderId,
          count: 0,
          delivery_address: '',
        },
        columns: [
          'password',
          'title',
          'products',
          'opening_finish_date',
          'price',
          'region',
          'type',
          'invitation',
          'edit',
          'participants_count'
        ],
      }
    },
    computed: {
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      }
    },
    watch: {
      '$route.params.tenderId': {
        immediate: true,
        async handler() {
          this.$client.get(`timeless-tenders/${this.$route.params.tenderId}`).then(({ data }) => {
            console.log('data', data.data)
            this.tenderData = data.data;
            this.mainPicture = data.data.pictures[0];
          })
          this.$client.get(`timeless-tenders/similar-tenders/${this.$route.params.tenderId}`).then(({ data }) => {
            console.log('data', data.data)
            this.similarTenders = data.data;
          })
        },
      },
    },
    validations: {
      order: {
        count: {required},
        delivery_address: {required},
      }
    },
    methods: {
      handleSimilarClick(tender){
        console.log('handle handleSimilarClick', tender);
        this.$router.push(`/timeless-tenders/tender/${tender.id}`)
      },
      handleOpenContract(){
        if(!this.$v.$invalid && this.selectedOffer.id && !this.countGreaterThenOffer) {
          console.log('handleOpenContract')
          console.log('tender', this.tenderData);
          console.log('offer', this.selectedOffer);
          console.log('order', this.order);
          this.contractData.code =this.tenderData.code;
          this.contractData.rows[0] = {
            name: this.tenderData.name,
            specification: this.tenderData.specification,
            unit: this.tenderData.unit,
            count: this.order.count,
            terms_of_purchase: this.tenderData.terms_of_purchase,
            delivery_terms: this.tenderData.delivery_terms,
            offer_delivery_terms: this.selectedOffer.delivery_terms,
            payment_terms: this.tenderData.payment_terms,
            delivery_address: this.order.delivery_address,
          };

          this.$modal.show('new-editor-modal', {
            action: 'save',
            fileName: 'contract_draft',
            editorTitle: 'Պայմանագրի նախագիծ'
          })
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
        }
      },
      async handleGetContract(contract){
        this.contractHtml = contract;
        this.$modal.hide('new-editor-modal')
        const fileHash = await this.generateFileHash(this.contractHtml);
        this.sendSignRequest(fileHash);
        console.log(fileHash)
      },
      async sendSignRequest(fileHash) {
        // Ensure we have selected an offer
        if (!this.selectedOffer.id) {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Նշված առաջարկը սխալ է!'
          });
          return;
        }

        // API Call to the backend to send the document for signing
        try {
          // const response = await this.$client.post('/sign-document', {
          //   file_hash: fileHash,
          //   scope: 'mts',  // Can also use 'xid_sign' depending on the provider
          //   phone_number: '37496336628',  // This should be the user's phone number
          //   format: 'pkcs1',  // Assuming pkcs1 as format
          //   reason: 'Do you want to sign the document?'
          // });

          // response { "status": "failed", "message": "UNKNOWN_CLIENT" }

          const response = await this.$client.post('/sign-document', {
            file_hash: fileHash,
            scope: 'xid_sign',  // Can also use 'xid_sign' depending on the provider
            format: 'pkcs1',  // Assuming pkcs1 as format
            reason: 'Do you want to sign the file?',
            ssn: '0963366281'
          });

          // response { "status": "failed", "message": "Mobile user with UserIdentifier 0123456789 does not exist." }

          console.log(response);

          if (response.data.status === 'OK') {
            this.$notify({
              group: 'foo',
              type: 'success',
              text: 'Պայմանագիրը հաջողությամբ ստորագրվել է'
            });
          } else {
            this.$notify({
              group: 'foo',
              type: 'error',
              text: 'Սխալ տեղի ունեցավ ստորագրման գործընթացում'
            });
          }
        } catch (error) {
          console.error(error);
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Սխալ տեղի ունեցավ ստորագրման գործընթացում'
          });
        }
      },
      async generateFileHash (documentContent) {
        const encoder = new TextEncoder();
        const data = encoder.encode(documentContent);

        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        return btoa(String.fromCharCode.apply(null, hashArray));
      },
      handleChangeCount(offer){
        this.totalAmount = +this.selectedOffer.price * this.order.count;
        this.countGreaterThenOffer = +this.selectedOffer.count < this.order.count;
      },
      handleSelectOffer(offer){
        this.selectedOffer = offer;
        this.totalAmount = +offer.price * this.order.count;
        this.countGreaterThenOffer = offer.count < this.order.count;
      },
      sendOrder(){
        if(!this.$v.$invalid && this.selectedOffer.id && !this.countGreaterThenOffer && this.contractHtml) {
          this.$modal.show('timeless-confirm-modal', {
            msg: 'tender',
            callback: async () => {
              this.order.timeless_offer_id = this.selectedOffer.id;
              this.order.contract = this.contractHtml;
              this.$client.post('timeless-tenders/sendOrder', this.order).then(({data}) => {
                if(data){
                  this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'Հաջողությամբ հաստատված է'
                  })
                  this.$modal.hide('timeless-confirm-modal');
                  this.$router.push('/timeless-tenders/buy/orders')
                }
              }).catch(() => {
                this.$notify({
                  group: 'foo',
                  type: 'error',
                  text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
                })
              })
            }
          })
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
        }
      },
      deleteTender(id){
        this.$client.delete(`timeless-tenders/${id}`).then(({data}) => {
          this.$client.get('manager/timeless-tenders').then(({data}) => {
            console.log('data', data.data)
            this.tenders = data.data;
          })
        })
      }
    },
  }
</script>
<style scoped>
.divider{
  margin: 6px 10px 16px;
}
.similar-tenders-text{
  color: #2D3036;
  font-size: 18px;
  line-height: 26px;
}
</style>

